import { CardHeader } from '@/components/card';
import {
  CardContent,
  CardMainActionButtonProps
} from '@/components/card/Card.component';
import { PlanFunds } from '@/services/Investment.service';
import formatters from '@/utils/Formatters';
import { Alert, Card, Divider, Stack, Typography } from '@mui/material';

import { FC } from 'react';

import { ChangeMapping } from '../re-enrollment/InvestmentAutocomplete.component';
import { ReenrollMappingTable } from '../re-enrollment/ReenrollMappingTable.component';

type ProgramChangeReviewProps = PlanFunds & {
  planId: number;
  effectiveDate: string;
  effectiveDateNote: string;
  isConfirming?: boolean;
  confirmButtonProps: CardMainActionButtonProps[];
  mappingButtonProps: CardMainActionButtonProps[];
  mappingTableContext: {
    changes: ChangeMapping[];
    setChanges?: (changes: ChangeMapping) => void;
  };
};

export const ProgramChangeReview: FC<ProgramChangeReviewProps> = props => {
  return (
    <Stack spacing={3}>
      {props.isConfirming && (
        <Card>
          <CardHeader
            actionButtonsProps={props.confirmButtonProps}
            title='Review'
          />
          <CardContent>
            <Stack spacing={2}>
              <Alert severity='warning'>
                <Typography color='rgba(0,0,0,0.6)' mb={2} variant='body2'>
                  You&apos;re about to change this plans&apos; investment
                  program. This could mean re-defaulting a saver&apos;s
                  investment election to a new QDIA.
                </Typography>
                <Typography color='rgba(0,0,0,0.6)' variant='body2'>
                  Submitting the below may impact savers&apos; investment
                  elections in the plan.
                </Typography>
              </Alert>
              <Divider />
              <Stack>
                <Typography color='rgba(0,0,0,0.87)' variant='body2'>
                  <strong>Plan Name:</strong> {props.name}
                </Typography>
                <Typography color='rgba(0,0,0,0.87)' variant='body2'>
                  <strong>Plan ID:</strong> {props.planId}
                </Typography>
              </Stack>
              <Stack>
                <Typography variant='subtitle2'>Effective Date</Typography>
                <Typography variant='body1'>
                  {formatters.formatFromIsoDateCustom(
                    props.effectiveDate,
                    'MM/DD/YYYY'
                  )}
                </Typography>
              </Stack>
              <Stack>
                <Typography variant='subtitle2'>Note</Typography>
                <Typography variant='body1'>
                  {props.effectiveDateNote}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      )}
      <Card>
        {!props.isConfirming && (
          <CardHeader
            actionButtonsProps={props.mappingButtonProps}
            title='Map investment strategies'
          />
        )}
        <CardContent disablePadding>
          <ReenrollMappingTable
            context={props.mappingTableContext}
            currentProgram={props.currentProgram}
            isConfirming={props.isConfirming}
            newProgram={props.newProgram}
          />
        </CardContent>
      </Card>
    </Stack>
  );
};
